<div class="body">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">done</mat-icon>
        <span>Vertragsartikel angelegt</span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <div class="contract-item-row" *ngFor="let contractItem of data">

            <div class="item-details-wrapper">
                {{contractItem.itemname}}
            </div>

            <div>
                <button mat-raised-button (click)="navigateToContract(contractItem.itemcontractid)">
                    Ansehen
                </button>
            </div>

        </div>

    </div>

</div>